import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Text, FormControl, FormLabel} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import useGiftCertificateFields from './use-giftCertificate-fields'
import Field from '@salesforce/retail-react-app/app/components/field'

const GiftCertificateFields = ({form, prefix = ''}) => {
    const fields = useGiftCertificateFields({form, prefix})

    const hideErrorInfoIcon = {
        '.chakra-form__error-message svg': {
            display: 'none'
        }
    }

    return (
        <Stack
            marginBottom={7}
            direction={{base: 'column', md: 'row'}}
            spacing={6}
            sx={hideErrorInfoIcon}
        >
            {/* TO section */}
            <Stack flex="1">
                <Text fontWeight="bold" mb={2}>
                    <FormattedMessage defaultMessage="To" id="gift_certificate.to" />
                </Text>

                <FormControl>
                    <FormLabel htmlFor={fields.receipientName.name}>
                        <Text as="span" color="errorRed1">
                            {'\u002A'}
                        </Text>
                        <FormattedMessage
                            defaultMessage="Recipient Name"
                            id="gift_certificate.recipient_name"
                        />
                    </FormLabel>
                    <Field {...fields.receipientName} label="" />
                </FormControl>

                <FormControl>
                    <FormLabel htmlFor={fields.receipientEmail.name}>
                        <Text as="span" color="errorRed1">
                            {'\u002A'}
                        </Text>
                        <FormattedMessage
                            defaultMessage="Recipient Email"
                            id="gift_certificate.recipient_email"
                        />
                    </FormLabel>
                    <Field {...fields.receipientEmail} label="" />
                </FormControl>
            </Stack>

            {/* FROM section */}
            <Stack flex="1">
                <Text fontWeight="bold" mb={2}>
                    <FormattedMessage defaultMessage="From" id="gift_certificate.from" />
                </Text>

                <FormControl>
                    <FormLabel htmlFor={fields.senderName.name}>
                        <Text as="span" color="errorRed1">
                            {'\u002A'}
                        </Text>
                        <FormattedMessage
                            defaultMessage="Sender Name"
                            id="gift_certificate.sender_name"
                        />
                    </FormLabel>
                    <Field {...fields.senderName} label="" />
                </FormControl>

                <FormControl>
                    <FormLabel htmlFor={fields.senderEmail.name}>
                        <Text as="span" color="errorRed1">
                            {'\u002A'}
                        </Text>
                        <FormattedMessage
                            defaultMessage="Sender Email"
                            id="gift_certificate.sender_email"
                        />
                    </FormLabel>
                    <Field {...fields.senderEmail} label="" />
                </FormControl>
            </Stack>
        </Stack>
    )
}

GiftCertificateFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default GiftCertificateFields
